import {Injectable} from '@angular/core';
import {MapLayersService} from './map-layers.service';
import * as L from 'leaflet';
import {MapPane, mapPane} from './models/map-pane.models';

@Injectable({providedIn: 'root'})
export class MapPaneService {
  constructor(private mapLayersService: MapLayersService) {
  }

  getPaneName(type: string): string {
    return type ? type : mapPane.REGION;
  }

  initPanes(map: L.Map) {
    if (!map) {
      return;
    }
    this.createPane(map, mapPane.TECH_WORK_AREA, 200);
    this.createPane(map, mapPane.REGION, 250);
    this.createPane(map, mapPane.DEMAND, 300);
    this.createPane(map, mapPane.RIDE_ALLOW, 350);
    this.createPane(map, mapPane.SPEED_LIMIT, 400);
    this.createPane(map, mapPane.FINISH_ALLOW, 450);
    this.createPane(map, mapPane.FINISH_RESTRICT, 500);
    this.createPane(map, mapPane.RIDE_RESTRICT, 550);
    this.createPane(map, mapPane.TRACK, 600);
    this.createPane(map, mapPane.PRIORITY_LAYER, 630);
    this.createPane(map, mapPane.GEOPOINT, 650, pane => {
      this.mapLayersService.geopointPane.next(pane);
    });
    this.createPane(map, mapPane.MARKER, 660);
  }

  private createPane(
    map: L.Map,
    name: MapPane,
    zIndex: number,
    callback?: (pane: HTMLElement) => void
  ) {
    let pane = map.getPane(name);

    if (!pane) {
      pane = map.createPane(name);
    }

    pane.style.zIndex = String(zIndex);

    if (callback) {
      callback(pane);
    }
  }
}
